import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FolderWithFileCheckmarkOutline = createIcon({
  displayName: 'FolderWithFileCheckmarkOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M19 9h-6.465c-.334 0-.647-.167-.832-.445l-1.406-2.109c-.186-.279-.498-.446-.832-.446h-4.465c-1.105 0-2 .895-2 2v11c0 1.105.895 2 2 2h14c1.105 0 2-.895 2-2v-8c0-1.105-.895-2-2-2Z"></path>
        <path d="M11.5 16.5l-1.5-1.5"></path>
        <path d="M14 14l-2.5 2.5"></path>
        <path d="M5 6v-1c0-1.105.895-2 2-2h10c1.105 0 2 .895 2 2v4"></path>
      </g>
      <path fill="none" d="M0 0h24v24h-24v-24Z"></path>
    </>
  ),
})

const FolderWithFileCheckmark: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FolderWithFileCheckmarkTwoTone} {...props} />

  return <CustomIcon as={FolderWithFileCheckmarkOutline} {...props} />
}

export default memo(FolderWithFileCheckmark)
